import React, { useState } from "react";
import { Image, Tab, Table, Tabs } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link, useNavigate, useParams } from "react-router-dom";

import { useAppApi } from "@/App";
import { ActionLogAction } from "@/const";
import { DevModal, YesNoColumn } from "@components/Helpers";
import { DefaultLayout } from "@components/Layouts";
import { CommonCard, ListingCard } from "@components/Pages";
import { is_str, url_reverse } from "@components/Utils";

export default function ActionLogScreen() {
    const { t } = useTranslation();
    const params = useParams();

    const header = t("Лог действий");
    return (
        <DefaultLayout>
            {params.id ? (
                <Edit header={header} kind={params.kind} id={params.id} />
            ) : (
                <List header={header} kind={params.kind} />
            )}
        </DefaultLayout>
    );
}

const List = ({ header, kind }) => {
    const { t } = useTranslation();
    const { apiData } = useAppApi(url_reverse("api:actionlog:list", { kind }));
    const [logInfo, setLogInfo] = useState(null);
    const navigate = useNavigate();

    if (!apiData) return;

    const handleSelect = (k) => {
        navigate({
            pathname: url_reverse("admin:actionlog:list", { kind: k }),
        });
    };

    const showLogInfo = (ev, obj) => {
        ev.preventDefault();
        setLogInfo(obj);
    };

    const DefautlList = () => {
        return (
            <Table hover responsive className="dmg-table">
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>{t("Логин")}</th>
                        <th>{t("Действие")}</th>
                        <th>{t("Класс объекта")}</th>
                        <th>{t("ID объекта")}</th>
                        <th>{t("Дата")}</th>
                        <th>{t("Пометка")}</th>
                        <th>{t("Метка")}</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {apiData.object_list?.map((obj) => (
                        <tr key={obj.id}>
                            <td>
                                <Link to={url_reverse("admin:actionlog:item", { kind, log_id: obj.id })}>{obj.id}</Link>
                            </td>
                            <td>{obj.account}</td>
                            <td>{obj.action}</td>
                            <td>{obj.entity_class}</td>
                            <td>
                                {obj.entity_class === "Game" ? (
                                    <Link to={url_reverse("games:admin", { game_id: obj.entity_id })}>
                                        {obj.entity_id}
                                    </Link>
                                ) : (
                                    obj.entity_id
                                )}
                            </td>
                            <td>{obj.datetime}</td>
                            <td>{obj.service_msg}</td>
                            <td>{obj.entity_label}</td>
                            <td>
                                {[
                                    ActionLogAction.CREATE,
                                    ActionLogAction.UPDATE,
                                    ActionLogAction.DELETE,
                                    ActionLogAction.CHANGE,
                                    ActionLogAction.CRUD,
                                    ActionLogAction.MISC,
                                ].includes(obj.action) && (
                                    <a href="" onClick={(ev) => showLogInfo(ev, obj)}>
                                        {t("Подробнее")}
                                    </a>
                                )}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        );
    };

    const OrdersList = () => {
        return (
            <Table hover responsive className="dmg-table">
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>{t("Логин")}</th>
                        <th>{t("Действие")}</th>
                        <th>{t("ID объекта")}</th>
                        <th>{t("Дата")}</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {apiData.object_list?.map((obj) => (
                        <tr key={obj.id}>
                            <td>
                                <Link to={url_reverse("admin:actionlog:item", { kind, log_id: obj.id })}>{obj.id}</Link>
                            </td>
                            <td>{obj.account}</td>
                            <td>{obj.action}</td>
                            <td>{obj.entity_id}</td>
                            <td>{obj.datetime}</td>
                            <td>
                                <a href="" onClick={(ev) => showLogInfo(ev, obj)}>
                                    {t("Подробнее")}
                                </a>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        );
    };

    return (
        <ListingCard header={header}>
            <Tabs activeKey={kind} transition={false} className="react-bootstrap-tabs-fix" onSelect={handleSelect}>
                <Tab eventKey="default" title={t("Общий")}>
                    <DefautlList />
                </Tab>
                <Tab eventKey="orders" title={t("Заказы")}>
                    <OrdersList />
                </Tab>
            </Tabs>

            <DevModal
                size="xl"
                show={logInfo}
                onHide={() => setLogInfo(null)}
                header={`[${logInfo?.id}]: ${logInfo?.action}`}
                body={
                    <>
                        {logInfo && logInfo.action === ActionLogAction.CRUD && (
                            <>
                                {[ActionLogAction.CREATE, ActionLogAction.UPDATE, ActionLogAction.DELETE].map(
                                    (action) =>
                                        logInfo.data[action]?.map((obj, idx) => (
                                            <div key={"crud_" + action + "_" + idx}>
                                                <i>
                                                    {action} #{idx + 1}
                                                </i>
                                                <DrawDiffStandart data={obj} />
                                            </div>
                                        ))
                                )}
                            </>
                        )}
                        {logInfo && logInfo.action !== ActionLogAction.CRUD && (
                            <>
                                {[ActionLogAction.CREATE, ActionLogAction.UPDATE, ActionLogAction.DELETE].includes(
                                    logInfo.action
                                ) && <DrawDiffStandart data={logInfo.data} />}
                                {logInfo.action === ActionLogAction.CHANGE && <DrawDiffChange data={logInfo.data} />}
                                {logInfo.action === ActionLogAction.MISC && <DrawDiffMisc data={logInfo.data} />}
                            </>
                        )}
                    </>
                }
            />
        </ListingCard>
    );
};

const Edit = ({ header, kind, id }) => {
    const { t } = useTranslation();
    const { apiData } = useAppApi(url_reverse("api:actionlog:item", { kind, log_id: id }));

    if (!apiData) return;

    return (
        <CommonCard header={header}>
            {apiData.object && (
                <>
                    <Table bordered>
                        <tbody>
                            <tr>
                                <th style={{ width: "20%" }}>{t("Действие")}</th>
                                <td>{apiData.object.action}</td>
                            </tr>
                            <tr>
                                <th>{t("Метка")}</th>
                                <td>{apiData.object.entity_label}</td>
                            </tr>
                            <tr>
                                <th>{t("Класс объекта")}</th>
                                <td>{apiData.object.entity_class}</td>
                            </tr>
                            <tr>
                                <th>{t("ID объекта")}</th>
                                <td>{apiData.object.entity_id}</td>
                            </tr>
                            <tr>
                                <th>{t("Дата")}</th>
                                <td>{apiData.object.datetime}</td>
                            </tr>
                            <tr>
                                <th>{t("Логин")}</th>
                                <td>{apiData.object.account}</td>
                            </tr>
                            <tr>
                                <th>{t("Скрипт")}</th>
                                <td>{apiData.object.source}</td>
                            </tr>
                        </tbody>
                    </Table>
                    {[ActionLogAction.CREATE, ActionLogAction.UPDATE, ActionLogAction.DELETE].includes(
                        apiData.object.action
                    ) && <DrawDiffStandart data={apiData.object.data} />}
                    {apiData.object.action === ActionLogAction.CHANGE && <DrawDiffChange data={apiData.object.data} />}
                </>
            )}
        </CommonCard>
    );
};

const DrawDiffStandart = ({ data }) => {
    const { t } = useTranslation();
    const key = data.old ? "old" : "new";
    const picture_types = ["ico", "jpeg", "jpg", "png"];

    const prepVal = (val, field) => {
        const ext = is_str(val) ? val.split(".").pop() : null;

        if (typeof val === "object") {
            if (val === null) {
                return "None";
            }
            return <pre>{JSON.stringify(val, null, 2)}</pre>;
        } else if (typeof val === "boolean") {
            return <YesNoColumn attr={val} />;
        } else if (field === "video" && val) {
            return (
                <>
                    <a href={val} target="_blank">
                        {val}
                    </a>
                    <video src={val} width="400" height="auto" controls="controls" />
                </>
            );
        } else if (picture_types.includes(ext) && val && val.indexOf("/hotbox/") === 0) {
            return (
                <a href={val} target="_blank">
                    <Image src={val} style={{ maxHeight: "150px", backgroundColor: "black", padding: "0px" }} />
                </a>
            );
        }
        return val;
    };

    return (
        <Table size="sm" bordered className="dev-actionlog__diff">
            <thead>
                <tr>
                    <th width="20%">{t("Поле")}</th>
                    <th width="40%">{t("Старое значение")}</th>
                    <th width="40%">{t("Новое значение")}</th>
                </tr>
            </thead>
            <tbody>
                {Object.keys(data[key]).map((field, ind) => {
                    const oldVal = data.old && data.old[field];
                    const newVal = data.new && data.new[field];
                    const prepOld = prepVal(oldVal, field);
                    const prepNew = prepVal(newVal, field);
                    if (prepOld === prepNew) {
                        return (
                            <tr key={field + ind} className="dev-actionlog__diff-identical">
                                <td>{field}</td>
                                <td>{prepOld}</td>
                                <td>-</td>
                            </tr>
                        );
                    }
                    return (
                        <tr key={field + ind}>
                            <td>{field}</td>
                            <td>{prepOld}</td>
                            <td>{prepNew}</td>
                        </tr>
                    );
                })}
            </tbody>
        </Table>
    );
};

const DrawDiffChange = ({ data }) => {
    const { t } = useTranslation();
    return (
        <Table size="sm" bordered className="dev-actionlog__diff">
            <thead>
                <tr>
                    <th>{t("Убрано")}</th>
                    <th>{t("Добавлено")}</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>{JSON.stringify(data["-"], null, 2)}</td>
                    <td>{JSON.stringify(data["+"], null, 2)}</td>
                </tr>
            </tbody>
        </Table>
    );
};

const DrawDiffMisc = ({ data }) => {
    return (
        <Table size="sm" bordered className="dev-actionlog__diff">
            <thead>
                <tr>
                    <th>DATA</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>{JSON.stringify(data, null, 2)}</td>
                </tr>
            </tbody>
        </Table>
    );
};
